import { useEffect } from 'react';

const APP_NAME = 'Trace Viewer';

/**
 * Updates `document.title` whenever `title` changes.
 *
 * - `undefined` → resets to bare `"Trace Viewer"`
 * - any string  → `"<title> — Trace Viewer"`
 *
 * Restores the previous title on unmount so nested callers
 * don't permanently clobber the parent title.
 */
export function usePageTitle(title: string | undefined): void {
    useEffect(() => {
        const previous = document.title;
        document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
        return () => {
            document.title = previous;
        };
    }, [title]);
}
